export default __webpack_public_path__ + "static/media/Perfil-inversionista.3f8e9f59.png";